var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-menu",
    {
      staticClass: "nav__notifications",
      attrs: {
        "md-active": _vm.isNotificationCardOpen,
        "md-align-trigger": "",
        "md-direction": "bottom-end",
        "data-test-id": "notifications"
      },
      on: {
        "update:mdActive": function($event) {
          _vm.isNotificationCardOpen = $event
        },
        "update:md-active": function($event) {
          _vm.isNotificationCardOpen = $event
        }
      }
    },
    [
      _c(
        "md-button",
        {
          staticClass: "nav__notifications-btn",
          attrs: {
            "md-menu-trigger": "",
            "data-test-id": "notifications-toggle-btn",
            "md-ripple": false
          }
        },
        [
          _c(
            "md-tooltip",
            {
              staticClass: "custom-tooltip",
              style: { width: "fit-content" },
              attrs: {
                "md-direction": "bottom",
                "md-active": _vm.tooltipActive,
                "data-test-id": "notifications-tooltip"
              },
              on: {
                "update:mdActive": function($event) {
                  _vm.tooltipActive = $event
                },
                "update:md-active": function($event) {
                  _vm.tooltipActive = $event
                }
              }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.i18n.lbl_notifications()) + "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("md-icon", {
            class: { "md-icon_active": _vm.isNotificationCardOpen },
            attrs: {
              "md-src": "/static/img/bell.svg",
              "data-test-id": "notifications-toggle-btn-icon"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "nav__notifications-label text_large" }, [
            _c(
              "span",
              {
                staticClass: "nav__notifications-counter",
                attrs: { "data-test-id": "notifications-counter" }
              },
              [_vm._v("\n        (" + _vm._s(_vm.notifCounter) + ")\n      ")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.notifCounter > 0
        ? _c(
            "md-menu-content",
            {
              ref: "notifContainer",
              staticClass: "redesign-menu nav__notifications-menu",
              attrs: { "data-test-id": "notifications-list-container" }
            },
            [
              _vm.getUnreadMessages.length > 0
                ? _vm._l(_vm.getUnreadMessages, function(msg, index) {
                    return _c(
                      "md-menu-item",
                      {
                        key: "unread_" + msg.message_key,
                        ref:
                          index === _vm.getUnreadMessages.length - 1
                            ? "lastUnreadMessage"
                            : null,
                        refInFor: true,
                        staticClass: "nav__notifications-item",
                        attrs: {
                          "data-test-id":
                            "notifications-list-item-" + msg.message_key
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "nav__notifications-content" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.getMessageText(msg)) +
                                "\n        "
                            )
                          ]
                        ),
                        _vm._v(
                          "\n\n        " +
                            _vm._s(_vm.checkRead(msg.id)) +
                            "\n      "
                        )
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.getUnreadInc.length > 0
                ? [
                    _c(
                      "md-menu-item",
                      {
                        staticClass: "notify_aml_title",
                        attrs: {
                          "data-test-id": "notifications-list-item-title"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "nav__notifications-content" },
                          [
                            _vm._v(
                              "\n          > " +
                                _vm._s(_vm.i18n.lbl_aml_notify_inc()) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.getUnreadInc, function(inc) {
                      return _c(
                        "md-menu-item",
                        {
                          key: "aml_" + inc.id,
                          staticClass: "nav__notifications-item notify_aml",
                          attrs: {
                            "data-notif-id": inc.notif_id,
                            "data-test-id":
                              "notifications-list-item-" + inc.notif_id
                          },
                          on: {
                            click: function($event) {
                              return _vm.openDialog(inc.id, 2)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav__notifications-content nav__notifications-content_indent"
                            },
                            [
                              _c("span", { staticClass: "notif-date" }, [
                                _vm._v(_vm._s(inc.timeStamp))
                              ]),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.i18n.lbl_aml_title()) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.getUnreadOut.length > 0
                ? [
                    _c(
                      "md-menu-item",
                      {
                        staticClass: "notify_aml_title",
                        attrs: {
                          "data-test-id": "notifications-list-item-title"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "nav__notifications-content" },
                          [
                            _vm._v(
                              "\n          > " +
                                _vm._s(_vm.i18n.lbl_aml_notify_out()) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.getUnreadOut, function(out) {
                      return _c(
                        "md-menu-item",
                        {
                          key: "inc_" + out.id,
                          staticClass: "nav__notifications-item notify_aml",
                          attrs: {
                            "data-notif-id": out.notif_id,
                            "data-test-id":
                              "notifications-list-item-" + out.notif_id
                          },
                          on: {
                            click: function($event) {
                              return _vm.openDialog(out.id, 3)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav__notifications-content nav__notifications-content_indent"
                            },
                            [
                              _c("span", { staticClass: "notif-date" }, [
                                _vm._v(_vm._s(out.timeStamp))
                              ]),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.i18n.lbl_aml_title()) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.getUnreadLymit.length > 0
                ? [
                    _c(
                      "md-menu-item",
                      {
                        staticClass: "notify_aml_title",
                        attrs: {
                          "data-test-id": "notifications-list-item-title"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "nav__notifications-content" },
                          [
                            _vm._v(
                              "\n          > " +
                                _vm._s(_vm.i18n.lbl_limit_title()) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.getUnreadLymit, function(lymit) {
                      return _c(
                        "md-menu-item",
                        {
                          key: "lymit_" + lymit.id,
                          staticClass: "nav__notifications-item notify_aml",
                          attrs: {
                            "data-notif-id": lymit.notif_id,
                            "data-test-id":
                              "notifications-list-item-" + lymit.notif_id
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("openLymitDialog", lymit.id)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav__notifications-content nav__notifications-content_indent"
                            },
                            [
                              _c("span", { staticClass: "notif-date" }, [
                                _vm._v(_vm._s(lymit.timeStamp))
                              ]),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.i18n.lbl_limit_s()) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.getUnreadErrorOut.length > 0
                ? [
                    _c(
                      "md-menu-item",
                      {
                        staticClass: "nnotify_aml_title",
                        attrs: {
                          "data-test-id": "notifications-list-item-title"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "nav__notifications-content" },
                          [
                            _vm._v(
                              "\n          > " +
                                _vm._s(_vm.i18n.lbl_aml_error_out()) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.getUnreadErrorOut, function(outerror) {
                      return _c(
                        "md-menu-item",
                        {
                          key: "out_" + outerror.id,
                          staticClass: "nav__notifications-item notify_aml",
                          attrs: {
                            "data-notif-id": outerror.notif_id,
                            "data-test-id":
                              "notifications-list-item-" + outerror.notif_id
                          },
                          on: {
                            click: function($event) {
                              return _vm.openDialog(outerror.id, -2)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav__notifications-content nav__notifications-content_indent"
                            },
                            [
                              _c("span", { staticClass: "notif-date" }, [
                                _vm._v(_vm._s(outerror.timeStamp))
                              ]),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.i18n.lbl_aml_title()) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.getUnreadErrorInc.length > 0
                ? [
                    _c(
                      "md-menu-item",
                      {
                        staticClass: "notify_aml_title",
                        attrs: {
                          "data-test-id": "notifications-list-item-title"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "nav__notifications-content" },
                          [
                            _vm._v(
                              "\n          > " +
                                _vm._s(_vm.i18n.lbl_aml_error_inc()) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.getUnreadErrorInc, function(incerror) {
                      return _c(
                        "md-menu-item",
                        {
                          key: "out_" + incerror.id,
                          staticClass: "nav__notifications-item notify_aml",
                          attrs: {
                            "data-notif-id": incerror.notif_id,
                            "data-test-id":
                              "notifications-list-item-" + incerror.notif_id
                          },
                          on: {
                            click: function($event) {
                              return _vm.openDialog(incerror.id, -1)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav__notifications-content nav__notifications-content_indent"
                            },
                            [
                              _c("span", { staticClass: "notif-date" }, [
                                _vm._v(_vm._s(incerror.timeStamp))
                              ]),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.i18n.lbl_aml_title()) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        : _c(
            "md-menu-content",
            {
              staticClass: "redesign-menu nav__notifications-menu",
              attrs: { "data-test-id": "notifications-empty-list-container" }
            },
            [
              _c(
                "md-menu-item",
                { attrs: { "data-test-id": "notifications-empty-list-item" } },
                [
                  _c("div", { staticClass: "nav__notifications-content" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.i18n.notification_no_new_notifications()) +
                        "\n      "
                    )
                  ])
                ]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a70b0062", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a70b0062","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/Notifications.vue
// module id = sqpf
// module chunks = 1